// extracted by mini-css-extract-plugin
export default {"container":"container--lClX3","labelText":"labelText--KTDcP","input":"input--ItCqB"};